export default "/assets/images/bbq-video-thumbnail.jpg?d514ad82a3d875f4e3b92d5626c0c670";